import { BLUE_100, BLUE_500, WHITE } from '../colors';
var fuseConfigLight = {
  config: {
    activeColor: BLUE_500,
    defaultColor: BLUE_100
  }
};
var fuseConfigDark = {
  config: {
    activeColor: BLUE_500,
    defaultColor: WHITE
  }
};
export default {
  light: fuseConfigLight,
  dark: fuseConfigDark,
  white: fuseConfigLight
};